import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-headline-small d-flex justify-content-between mt-0 mb-4" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "text-body-medium d-grid gap-2" }
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = { style: {"font-size":"13px","color":"gray","font-weight":"bold"} }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "d-flex search-buttons" }

import AccountNamesAutoComplete from "@/components/AutoCompletes/AccountNamesAutoComplete.vue";
import OrganizationAutoComplate from "@/components/AutoCompletes/OrganizationAutoComplate.vue";
import DepartmentAutoComplete from "@/components/AutoCompletes/DepartmentAutoComplete.vue"
import getAccountsResponse from "@/types/requests/getAccounts";
import getDepartmentResponse from '@/types/responses/getDepartment'
import { DEPARTMENT_OFFICE_TYPE } from "@/services/consts"
import { Ref, onMounted, ref, computed, watch } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import { ROLES } from "@/services/consts/account";
import i18n from '@/lang/i18n';
import { saveDataToSessionStorage, loadDataFromSessionStorage, clearSessionStorage } from "@/services/functions/sessionStorage";

type officeType = {
  id: number | null,
  name: string,
  type: string
}

type selectedOfficeType = {
  id: number | null,
  type: string,
  name: string,
  departments: any[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountsSearchForm',
  props: {
    loading: { type: Boolean }
  },
  emits: ['search', 'clear'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const MANAGEMENT_OFFICE = {
  id: 1,
  name: i18n.global.t('pages.accounts.managementOffice'),
  type: 'ManagementOffice'
}
const SUB_MANAGEMENT_OFFICE = {
  id: 2,
  name: i18n.global.t('pages.accounts.subManagementOffice'),
  type: 'SubManagementOffice'
}
const INSTALLATION_OFFICE = {
  id: 3,
  name: i18n.global.t('pages.accounts.installationOffice'),
  type: 'InstallationOffice'
}
const OPERATION_OFFICE = {
  id: 4,
  name: i18n.global.t('pages.accounts.operationOffice'),
  type: 'OperationOffice'
}
const selectedOfficeableType: Ref<officeType> = ref({ id: null, name: "", type: "" })
const showableOfficeableTypes: Ref<officeType[]> = ref([])
const selectedOffice: Ref<selectedOfficeType> = ref({ id: null, type: "", name: "", departments: [] })
const selectedAccountsName: Ref<getAccountsResponse | undefined> = ref()
const selectedDepartment: Ref<getDepartmentResponse | undefined> = ref()
const status: Ref<string> = ref('only-active')
const hide: Ref<boolean> = ref(false)
const isDepartment: Ref<boolean> = ref(false)
const roleId: Ref<number | undefined> = ref(undefined)

onMounted(() => {
  Api().getSelfAccount().then((data) => {
    isDepartment.value = data.login_organization_type == DEPARTMENT_OFFICE_TYPE
    const type = data.login_organization_type?.split('\\')[2];
    switch (type) {
      case MANAGEMENT_OFFICE.type:
        showableOfficeableTypes.value = [MANAGEMENT_OFFICE, SUB_MANAGEMENT_OFFICE, INSTALLATION_OFFICE, OPERATION_OFFICE];
        break;
      case SUB_MANAGEMENT_OFFICE.type:
        showableOfficeableTypes.value = [SUB_MANAGEMENT_OFFICE, INSTALLATION_OFFICE, OPERATION_OFFICE];
        break;
      case OPERATION_OFFICE.type:
        showableOfficeableTypes.value = [OPERATION_OFFICE];
        break;
      default:
        showableOfficeableTypes.value = [];
    }
    if (showableOfficeableTypes.value.length) {
      showableOfficeableTypes.value.unshift({ id: null, type: "", name: "" });
    }
    const savedFormValues = loadDataFromSessionStorage('accountSearchForm');
    if (savedFormValues) {
      selectedOfficeableType.value = savedFormValues.officeable_type;
      selectedOffice.value = savedFormValues.selected_office;
      selectedAccountsName.value = savedFormValues.account_name;
      selectedDepartment.value = savedFormValues.department;
      roleId.value = savedFormValues.role_id;
      status.value = savedFormValues.status;
    }
    watch(() => selectedOffice.value, (newValue) => {
      const isIncluded = newValue?.departments.some(department => department.id === selectedDepartment.value?.id)
      if (!isIncluded) {
        selectedDepartment.value = undefined;
      }
    });
  })
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchBtnLabel = computed(() => {
  return props.loading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec')
})

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

function handleClickSearch() {
  const params = {
    officeable_type: selectedOfficeableType.value.id,
    officeable_id: selectedOffice.value?.id,
    type_class: selectedOffice.value?.type ? 'App\\Models\\' + selectedOffice.value.type : null,
    account_name: selectedAccountsName.value?.name,
    department_id: selectedDepartment.value?.id,
    role_id: roleId.value,
    status: status.value
  };
  emits('search', params);
  saveDataToSessionStorage('accountSearchForm', {
    officeable_type: selectedOfficeableType.value,
    selected_office: selectedOffice.value,
    account_name: selectedAccountsName.value,
    department: selectedDepartment.value,
    role_id: roleId.value,
    status: status.value,
  });
}

function clearForm() {
  selectedOfficeableType.value = { id: null, name: "", type: "" }
  selectedOffice.value = { id: null, type: "", name: "", departments: [] }
  selectedAccountsName.value = { id: undefined, name: "", role_id: undefined };
  roleId.value = undefined;
  status.value = 'only-active';
  clearSessionStorage('accountSearchForm');
  emits('clear');
}

function toggleSidebar() {
  hide.value = !hide.value
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_select, _mergeProps({
          class: "mb-1",
          modelValue: selectedOfficeableType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOfficeableType).value = $event)),
          items: showableOfficeableTypes.value,
          "item-title": "name",
          "item-value": "id"
        }, {'return-object': true}, {
          label: _unref(i18n).global.t('pages.accounts.accountCategory'),
          clearable: false
        }), null, 16, ["modelValue", "items", "label"]),
        _createVNode(OrganizationAutoComplate, {
          class: "mb-1",
          modelValue: selectedOffice.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOffice).value = $event)),
          selectedOfficeableType: selectedOfficeableType.value
        }, null, 8, ["modelValue", "selectedOfficeableType"]),
        _createVNode(AccountNamesAutoComplete, {
          modelValue: selectedAccountsName.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedAccountsName).value = $event)),
          class: "mb-1",
          operationOffices: selectedOffice.value ? [selectedOffice.value] : []
        }, null, 8, ["modelValue", "operationOffices"]),
        _createVNode(DepartmentAutoComplete, {
          modelValue: selectedDepartment.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDepartment).value = $event)),
          class: "mb-1",
          selectFirstIfOnlyOne: isDepartment.value,
          operationOffices: selectedOffice.value ? [selectedOffice.value] : []
        }, null, 8, ["modelValue", "selectFirstIfOnlyOne", "operationOffices"]),
        _createVNode(_component_v_select, {
          modelValue: roleId.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((roleId).value = $event)),
          class: "mb-1",
          items: _unref(ROLES),
          "item-title": "name",
          "item-value": "value",
          label: _unref(i18n).global.t('pages.accounts.role')
        }, null, 8, ["modelValue", "items", "label"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.common.filter.status.title')), 1),
          _createVNode(_component_v_radio_group, {
            modelValue: status.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((status).value = $event)),
            class: "radio-group-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                value: "only-active",
                label: _unref(i18n).global.t('pages.common.filter.status.onlyActive'),
                color: "blue"
              }, null, 8, ["label"]),
              _createVNode(_component_v_radio, {
                value: "all",
                label: _unref(i18n).global.t('pages.common.filter.status.all'),
                color: "blue"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_divider, {
          thickness: 3,
          class: "my-2"
        }),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: handleClickSearch,
            style: _normalizeStyle({
              backgroundColor : __props.loading ? '#B3B8BB' : ''
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchBtnLabel.value), 1)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            onClick: clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 2)
  ], 2))
}
}

})